import React from 'react';

import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import { Typography, useMediaQuery, useTheme } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';

import { ListingsSearchContext } from '../../ListingsSearchContext';

import styles from './SearchUrgencyMessage.module.css';

export const SearchUrgencyMessage = () => {
  const { activeTenantsCount, allFilters } = ListingsSearchContext.useContext();
  const { T } = useIntl();
  const theme = useTheme();
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    activeTenantsCount > 0 &&
    allFilters.cityName && (
      <div className={styles.root}>
        <ScreenSearchDesktopIcon className={styles.icon} />
        <Typography
          variant={isSMDown ? 'body4' : 'body3'}
          dangerouslySetInnerHTML={{
            __html: T(
              'LBL_SEARCH_URGENCY_MESSAGE',
              activeTenantsCount,
              allFilters.cityName,
            ),
          }}
        />
      </div>
    )
  );
};
